// Which guest on a trip a license or tag belongs to — one rule for the Lodge
// iOS app and the web Guide Portal, which both show licenses on the guest.
//
// The license's ClientID, except where its holder name is exactly another
// guest's: before the clients sent clientId, every license added in the field
// was saved under the trip's organizer, and only HolderName said whose it was.
// null = no guest on the trip can claim it (shown on the trip, so it never
// disappears).

const lc = (v?: string | null) => String(v || "").trim().toLowerCase();

export interface LicenseLike { ClientID?: string | null; HolderName?: string | null }
export interface GuestLike { clientId: string; name: string }

export function licenseOwner(l: LicenseLike, party: GuestLike[]): string | null {
  const byName = party.filter((p) => lc(p.name) && lc(p.name) === lc(l.HolderName));
  if (byName.length === 1) return lc(byName[0].clientId);
  const byId = party.find((p) => lc(p.clientId) === lc(l.ClientID));
  return byId ? lc(byId.clientId) : null;
}

export function licensesForGuest<T extends LicenseLike>(licenses: T[], party: GuestLike[], clientId: string): T[] {
  return licenses.filter((l) => licenseOwner(l, party) === lc(clientId));
}

export function unlinkedLicenses<T extends LicenseLike>(licenses: T[], party: GuestLike[]): T[] {
  return licenses.filter((l) => !licenseOwner(l, party));
}
